import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'

//request.js里写拦截码，对后端返回的特定码进行拦截然后做相应的操作
// 创建axios实例
let baseRepairURL = process.env.NODE_ENV === 'production' ? config.REPAIRAPI_ROOT : process.env.REPAIRAPI_ROOT;
// let baseRepairURL = process.env.REPAIRAPI_ROOT;
// const Config=JSON.parse(localStorage.getItem('Config'))
// if (Config) {
//     baseRepairURL = Config.REPAIRAPI_ROOT;
//   }
//   else {
//     if (process.env.NODE_ENV === 'production') {
//       $.ajax({
//         type: "get",
//         url: "serverconfig.json",
//         data: '',
//         async: false,
//         dataType:"json",
//         success: function (config) {
//           baseRepairURL = config.REPAIRAPI_ROOT;
//         }
//       });
//     }
//   }
const service = axios.create({
	baseURL:baseRepairURL, // api的base_url
	timeout: 15000, // 请求超时时间
});
// respone拦截器
service.interceptors.response.use(
	response => {
		if(response.status == '200' || response.status == 200) {
				return response
		} else {
			return Promise.reject('error')
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		});
		return Promise.reject(error)
	}
)

export default service
